export default __webpack_public_path__ + "static/media/construction-bg.8c2c9b33.jpeg";